import React from 'react'

export const A11yContext = React.createContext();
export function A11yProvider({...props}) {
  const [a11yMode, setA11yMode] = React.useState(false);
  return (
    <A11yContext.Provider value={{a11yMode, setA11yMode}} {...props} />
  )
}
